import { ListActionConditionContext, RecordActionConditionContext } from 'modules/record/record-producer/types/record-producer-actions';
import { ConditionEvaluationContext, evaluateConditionAst } from './conditionEvaluator';

export function evaluateCondition(
    conditions: any,
    context: RecordActionConditionContext | ListActionConditionContext
): boolean {
    try {
        return evaluateConditionAst(conditions, context as unknown as ConditionEvaluationContext);
    } catch (error) {
        console.error('Condition evaluation failed', {
            condition: conditions,
            context,
            error
        })
        return false
    }
}
